export default [
  "AcceptanceHierarchy",
  "CASEmanInterfaceConfiguration",
  "CASEmanIncomeImport",
  "FlexibleWorknormManagement",
  "Flexitime",
  "InterruptsOnClientView",
  "InvoiceDetails",
  "ManagementView",
  "OfferCalculator",
  "OvertimeManagement",
  "PartTimeVacation",
  "PowerUser",
  "ProfitabilityView",
  "ProgressBar",
  // "ProjectsFromErpSystem",
  // "ProjectsSetManually",
  "Projects",
  "PublicApi",
  "Timer",
  "VacationReporting",
  "View360",
  // "OfflineWorkingMode",
  "OutputType",
  "OvertimeRequest",
  "InteractiveNotes",
  "ClientMdpIdAvailable",
  "ClientMdpIdRequired",
  "D365Integration"
];
